/**
 * Shared "read full review" modal.
 *
 * Any capped review card exposes a `[data-review-full]` trigger inside a
 * `[data-review-card]` element that holds a `[data-review-head]` (author block) and
 * a hidden `[data-review-quote]` (full quote). Clicking the trigger copies those into
 * a single shared modal. Used by the testimonials slider and the references (zigzag)
 * block. Idempotent — safe to call from multiple components.
 */
let modalEl = null;

export function ensureReviewModal() {
  if (modalEl) return;

  modalEl = document.createElement('div');
  modalEl.className = 'testimonial-modal';
  modalEl.hidden = true;
  modalEl.innerHTML = `
    <div class="testimonial-modal__dialog" role="dialog" aria-modal="true">
      <button type="button" class="testimonial-modal__close" aria-label="Close">&times;</button>
      <div class="testimonial-card__head"></div>
      <blockquote class="testimonial-modal__quote"></blockquote>
    </div>`;
  document.body.appendChild(modalEl);

  const close = () => {
    modalEl.hidden = true;
    document.body.style.overflow = '';
  };
  modalEl.addEventListener('click', (e) => {
    if (e.target === modalEl || e.target.closest('.testimonial-modal__close')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modalEl.hidden) close();
  });

  // Delegated: open the full quote for any "show full" trigger.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-review-full]');
    if (!btn) return;
    const card = btn.closest('[data-review-card]');
    if (!card) return;

    const head = card.querySelector('[data-review-head]');
    const full = card.querySelector('[data-review-quote]');
    modalEl.querySelector('.testimonial-card__head').innerHTML = head ? head.innerHTML : '';
    modalEl.querySelector('.testimonial-modal__quote').innerHTML = full ? full.innerHTML : '';

    modalEl.hidden = false;
    document.body.style.overflow = 'hidden';
  });
}
